module.exports = __webpack_public_path__ + "static/media/lensfest_lobby.51a95468.png";